import React from 'react';

import { Link } from 'react-router-dom';
import footer from '../images/footslogo.png'


const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p>
            Hotel Celebrations Rooms and Banquets Lucknow is a popular event venue that provides stylish and chic banquets for hosting a range of events. Perfect for close-knit gatherings, the rooftop can host up to 250 guests, while Hall 1 & Hall 2 can accommodate up to 250 and 150 guests here, respectively. With warm-welcoming interiors and plush seating arrangements, the venue ensures that guests can enjoy the event in style.
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul style={{marginLeft:'60px'}}>
              <li><Link to="/">Home</Link></li><br/>
              <li><Link to="/about">About</Link></li><br/>
              <li><Link to="/Catogery">Services</Link></li><br/>
               <li><Link to="/gallery">Gallery</Link></li><br/>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Services</h3>
            <ul className="interior-services-list">
              <li>Weddings </li>
              <li>Engagements</li>
              <li>Receptions</li>
              <li>Birthdays</li>
              <li>Anniversaries</li>
              <li>Corporate Meetings</li>
              <li>Social Events</li>
            
             
            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️ celebrationsroombanquit@gmail.com</p>
            <p> 📞 Phone: +91 8081048334</p>
            <p>📍 Address:   Near Vijay Nagar, Bhagwati Vihar, Krishna Nagar, police chowki, Lucknow, Uttar Pradesh 226005</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} HOTEL CELEBRATIONS ROOM BANQUETS  All Rights Reserved.</p>

          <p>Powered By <img src={footer}/>   </p>
        
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/+918081048334"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>



<a
  href="tel:+918081048334"
  className="call-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="https://img.icons8.com/color/48/000000/phone.png" alt="Call" />
</a>

      <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.google.com" class="google"><i class="fa fa-google"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div>







    </>
  );
};

export default Footer;
